import * as React from 'react';
import { Logo } from '@/shared/components/logo';
import { Paper } from '@/shared/components/ui/paper';
export interface AuthLayoutProps {
  children?: React.ReactNode;
}
export const AuthLayout = (props: AuthLayoutProps): React.ReactNode => {
  const {
    children
  } = props;
  return <>
      <div className="flex h-full">
        <Paper className="flex h-full w-full flex-col border-r px-4 py-10 sm:p-10 md:max-w-[50%]" variant="grid">
          <Logo className="inline-block md:mb-auto" />

          <div className="my-auto flex items-center justify-center md:hidden">{children}</div>

          <div>
            <p className="mb-2 line-clamp-5 text-sm">
              &ldquo;Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae dolor voluptate culpa sapiente unde
              quod recusandae, voluptatum numquam, rem, ipsa eligendi corporis cupiditate dicta accusantium eos.
              Nesciunt quas sed quam sint perspiciatis dolorem dicta maiores ullam illum animi. Hic soluta tempora
              architecto, voluptas ipsam earum illo iure sint fugiat quo.&rdquo;
            </p>

            <p className="text-right text-sm text-brand-accent-light">Steve Jobs</p>
          </div>
        </Paper>

        <div className="hidden h-full w-full flex-1 items-center justify-center md:flex md:max-w-[50%]">{children}</div>
      </div>
    </>;
};